// extracted by mini-css-extract-plugin
export default {"wrapper":"X0-z","play":"Y0-z"};